




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import HomeFooterItem from '@/components/home/HomeFooterItem.vue';
import * as c_Interface from '@/interface/components/home';

@Component({
  components: { HomeFooterItem },
})
export default class HomeFunctionSection extends Vue {}
